import { useEffect, useState } from 'react';
import apis from '../../app/apis';
import cts from '../../app/cts';
import getAlphabeticMaterials from './helpers';

/**
 * Get material groups
 */
export const useMaterialGroup = (localityId) => {
  const [materials, setMaterials] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getMaterials = async () => {
      try {
        const { data } = await cts('get', apis.wgwMaterialGroupApi(localityId));
        if (!data.header.success) {
          throw new Error();
        }
        setMaterials(data.content.results);
      } catch (e) {
        setError('Error getting materials');
      } finally {
        setLoading(false);
      }
    };
    if (localityId) {
      getMaterials();
    }
  }, [localityId]);

  return {
    materials,
    error,
    loading
  };
};


/**
 * Get material list
 */
export const useMaterialList = (localityId) => {
  const [materials, setMaterials] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getMaterials = async () => {
      try {
        const { data } = await cts('get', apis.wgwMaterialListApi(localityId));
        if (!data.header.success) {
          throw new Error();
        }
        const sortedMaterials = getAlphabeticMaterials(data.content.results);
        setMaterials(sortedMaterials);
      } catch (e) {
        setError('Error getting materials');
      } finally {
        setLoading(false);
      }
    };
    getMaterials();
  }, [localityId]);

  return {
    materials,
    error,
    loading
  };
};
